import type { User } from '~/types/ecommerce/generated.codegen';

export const UserRestMock = (): User => ({
  email: 'vivianeggentil@gmail.com',
  fullName: 'Testes QA Nao mexer',
  id: 74393,
  profile: 'gerente',
  partner: {
    acceptedCurrentOperatingAgreement: true,
    address: {
      city: 'São Paulo',
      complement: 'apto 42',
      district: 'Consolação',
      number: '164',
      state: 'SP',
      street: 'Rua Bela Cintra',
      zipcode: '01415000',
    },
    id: 90891,
    recipient: {
      email: 'vivianeggentil@gmail.com',
      name: 'Testes QA Não mexer',
      phone: '+55 (11) 10009-1009',
    },
    tradingName: 'Olavo Rocha MEI',
    corporateName: 'Olavo Rocha MEI',
    state_registration: '1234567890',
  },
});
